let appSignalClient: import('@appsignal/javascript').default | undefined;

export async function loadAppSignal(key: string, namespace: string) {
  if (!appSignalClient) {
    const appSignal = await import('@appsignal/javascript');

    appSignalClient = new appSignal.default({
      key,
      namespace,
      revision: __COMMIT_HASH__,
    });
  }

  return appSignalClient;
}
